import { get } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import vpLogo from '../../Assets/images/logo.svg';
import PrintableApplicationDetail from './PrintableApplicationDetail';
import signs from '../../Lib/Constants/signatures';

import PrintableApplicationCheckbox from './PrintableApplicationCheckbox';
import PrintableApplicationSignature from './PrintableApplicationSignature';

const useStyles = makeStyles()((theme) => ({
  block: {
    display: 'flex',
    padding: '0px 5px',
  },
  header: {
    padding: '15px 0px',
  },
  logo: {
    alignItems: 'center',
    background: get(theme, 'palette.primary.main'),
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 5px',
  },
  print: {
    border: `1px solid ${get(theme, 'palette.white.main')}`,
    color: get(theme, 'palette.white.main'),
  },
  root: {
    padding: '0px 40px 40px 40px',
  },
}));

export default function PrintableApplication(props) {
  const { classes } = useStyles();

  function RequiredForm() {
    const { vendor } = props;

    if (vendor.country === 'US') {
      return (
        <PrintableApplicationCheckbox
          label="W9 Form"
          checked={get(vendor, 'w9_form.exists')}
        />
      );
    }
    if (vendor.is_individual) {
      return (
        <PrintableApplicationCheckbox
          label="W8BEN Form"
          checked={get(vendor, 'w8ben_form.exists')}
        />
      );
    }
    return (
      <PrintableApplicationCheckbox
        label="W8BEN-E Form"
        checked={get(vendor, 'w8bene_form.exists')}
      />
    );
  }

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.logo}>
        <img src={vpLogo} alt="logo" />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h4" className={classes.header}>
          Vendor Primary Information
        </Typography>
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationDetail
          label="Registered Legal Name"
          value={get(props.vendor, 'legal_name')}
        />
        <PrintableApplicationDetail
          label="Company Name"
          value={get(props.vendor, 'company_name')}
        />
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationDetail
          label="Email"
          value={get(props.vendor, 'email')}
        />
      </Grid>
      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationDetail
          label="Requester"
          value={get(props.vendor, 'invite_token.requesting_party')}
        />
        <PrintableApplicationDetail
          label="Reason for Adding"
          value={get(props.vendor, 'invite_token.reason')}
        />
      </Grid>
      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationDetail label="" value="" />
        <PrintableApplicationDetail
          label="INCO Term"
          value={get(props.vendor, 'invite_token.company_type')}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h4" className={classes.header}>
          Vendor Address Information
        </Typography>
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationDetail
          label="Country"
          value={get(props.vendor, 'country')}
        />
        <PrintableApplicationDetail label="" value="" />
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationDetail
          label="Street Address"
          value={get(props.vendor, 'address')}
        />
        <PrintableApplicationDetail
          label="Apt/Suite/ETC"
          value={get(props.vendor, 'address_2')}
        />
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationDetail
          label="City"
          value={get(props.vendor, 'city')}
        />
        <PrintableApplicationDetail label="" value="" />
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationDetail
          label="State or Province"
          value={get(props.vendor, 'state')}
        />
        <PrintableApplicationDetail
          label="Zip or Postal Code"
          value={get(props.vendor, 'zip')}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h4" className={classes.header}>
          Additional Details
        </Typography>
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationCheckbox
          label="Signed Vendor Agreement"
          checked={get(props.vendor, 'vendor_agreement.exists')}
        />
        <PrintableApplicationDetail label="" value="" />
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationCheckbox
          label="Certificate of Insurance"
          checked={get(props.vendor, 'certificate_of_insurance.exists')}
        />
        <PrintableApplicationDetail label="" value="" />
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <RequiredForm />
        <PrintableApplicationDetail label="" value="" />
      </Grid>

      <Grid item xs={12} className={classes.block}>
        <PrintableApplicationCheckbox
          label="Prop 65"
          checked={get(props.vendor, 'proposition65.exists')}
        />
        <PrintableApplicationDetail label="" value="" />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h4" className={classes.header}>
          Approval Signatures
        </Typography>
      </Grid>

      {signs.map((sign) => (
        <Grid item xs={12} className={classes.block} key={sign}>
          <PrintableApplicationSignature name={sign} />
        </Grid>
      ))}
    </Grid>
  );
}

PrintableApplication.propTypes = {
  vendor: PropTypes.shape({}).isRequired,
};
